//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import showroomSettingsFiltersTemplate from '@legacy-components/common/universal-image-actions/showroom-settings-filters.html';

(function () {
  const uia = angular.module('uia');
  uia.component('showroomSettingsFilters', {
    bindings: {
      allProductsCrawled: '<',
      itemId: '<',
      filterState: '<',
      onFiltersUpdated: '<',
      startingProductList: '<',
      onProductsUpdated: '<',
      startingLabels: '<',
      onLabelsUpdated: '<',
      useCuratedRecommendations: '<',
      onCuratedRecommendationsUpdated: '<',
    },
    template: showroomSettingsFiltersTemplate,
    controller: [
      '$scope',
      '$rootScope',
      'ShowroomService',
      'TrackingService',
      function ($scope, $rootScope, ShowroomService, TrackingService) {
        this.filtersCollapsed = true;
        this.trackingCategory = ShowroomService.getTrackingCategory();

        const recordFiltersChangedEvents = (filterType, filterState) => {
          let filterChangeAction;

          if (filterState.isSelected) {
            filterChangeAction = `FilterSelected${filterType}`;
          } else {
            filterChangeAction = `FilterUnselected${filterType}`;
          }
          TrackingService.recordEvent(
            this.trackingCategory,
            ShowroomService.getTrackingAction(),
            filterChangeAction,
          );
        };

        const updateFilters = () => {
          this.onFiltersUpdated(this.filterState);
        };

        this.helpLinkClicked = (linkName) => {
          TrackingService.recordEvent(
            this.trackingCategory,
            ShowroomService.getTrackingAction(),
            `HelpLinkClicked${linkName}`,
          );
        };

        this.toggleFiltersCollapsed = () => {
          this.filtersCollapsed = !this.filtersCollapsed;
        };

        this.onFiltersChanged = _.debounce((filterType, filterInfo) => {
          updateFilters();
          recordFiltersChangedEvents(filterType, filterInfo);
        }, 200);

        this.onUseCuratedRecsUpdated = (newValue) => {
          TrackingService.recordEvent(
            this.trackingCategory,
            ShowroomService.getTrackingAction(),
            `UseCuratedRecs${newValue ? 'Selected' : 'Unselected'}`,
          );
          this.onCuratedRecommendationsUpdated(newValue);
        };

        this.$onInit = () => {};
      },
    ],
  });
})();
